import React, { ChangeEventHandler } from 'react';
import FormControl from '@mui/material/FormControl';
import { emptyFn } from '@core/interfaces/emptyFn';
import InputComponent from '@ui/components/Input/Input.component';
import useDictionary from '@ui/hooks/useDictionary';
import SwitchComponent from './Switch.component';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    timeSyncSatsState: boolean;
    timeSyncGsmState: boolean;
    timeSyncNtpState: boolean;
    timeSyncSatsSupported: boolean;
    timeSyncGsmSupported: boolean;
    timeSyncNtpSupported: boolean;
    ntpAddress: string;
    ntpPort: number | null;
    lang: lang;
    onTimeSyncSatsStateChange: emptyFn;
    onTimeSyncGsmStateChange: emptyFn;
    onTimeSyncNtpStateChange: emptyFn;
    onNtpAddressChange: ChangeEventHandler<HTMLInputElement>;
    onNtpPortChange: ChangeEventHandler<HTMLInputElement>;
    onInputClick: emptyFn;
}

const Component: React.FC<IProps> = ({
    timeSyncSatsState,
    timeSyncGsmState,
    timeSyncNtpState,
    timeSyncSatsSupported,
    timeSyncGsmSupported,
    timeSyncNtpSupported,
    ntpAddress,
    ntpPort,
    lang,
    onTimeSyncSatsStateChange,
    onTimeSyncGsmStateChange,
    onTimeSyncNtpStateChange,
    onNtpAddressChange,
    onNtpPortChange,
    onInputClick,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <FormControl className="device-settings__form" component="form">
            <SwitchComponent
                alarmState={timeSyncSatsState}
                name={'timeSyncSatsState'}
                disabled={!timeSyncSatsSupported}
                tooltip={getWord('timeSyncSatsStateTooltip')}
                onAlarmStateChange={onTimeSyncSatsStateChange}
            />
            <SwitchComponent
                alarmState={timeSyncGsmState}
                name={'timeSyncGsmState'}
                disabled={!timeSyncGsmSupported}
                tooltip={getWord('timeSyncGsmStateTooltip')}
                onAlarmStateChange={onTimeSyncGsmStateChange}
            />
            <SwitchComponent
                alarmState={timeSyncNtpState}
                name={'timeSyncNtpState'}
                disabled={!timeSyncNtpSupported}
                tooltip={getWord('timeSyncNtpStateTooltip')}
                onAlarmStateChange={onTimeSyncNtpStateChange}
            />
            <InputComponent
                label="ntpAddress"
                name="ntp-address"
                type="text"
                description="ntpAddressTooltip"
                lang={lang}
                disabled={!timeSyncNtpSupported || !timeSyncNtpState}
                value={ntpAddress}
                onChange={onNtpAddressChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="ntpPort"
                name="ntp-port"
                type="number"
                description="ntpPortTooltip"
                numberProps={{
                    min: 0,
                    max: 65535,
                }}
                lang={lang}
                disabled={!timeSyncNtpSupported || !timeSyncNtpState}
                value={ntpPort}
                onChange={onNtpPortChange}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
        </FormControl>
    );
};

const TimeSyncSettingsComponent = React.memo(Component);

export default TimeSyncSettingsComponent;
